import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';

import { IfiStore } from '../stores/ifi.store';

export const IfiSummaryGuard: CanMatchFn = () => {
  const ifiStore = inject(IfiStore);
  const router = inject(Router);

  if (!ifiStore.loadingStatus().isLoaded) {
    return router.createUrlTree(['ifi', 'ifi-form']);
  }

  return true;
};
